import React from "react";
import moment from "moment";
import { SubcontractorInvoiceFragment } from "@graphql";
import { Typography } from "@material-ui/core";
import { InboxArrowDown, InboxArrowUp } from "mdi-material-ui";
import locale from "@bonliva-crm/locale";
import { useTheme } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  data: SubcontractorInvoiceFragment;
};

export function SubcontractorInvoiceCard(props: Props) {
  const { data } = props;
  const theme = useTheme<ThemeType>();

  if (!data) {
    return null;
  }

  const iconStyle = { marginRight: 16 };

  const icon = data.Credit ? (
    <InboxArrowUp style={{ ...iconStyle, color: theme.palette.error.main }} />
  ) : (
    <InboxArrowDown style={{ ...iconStyle, color: theme.palette.success.main }} />
  );

  const details = [];
  details.push(`#${data.GivenNumber}`);
  details.push(`${locale.Total}: ${data.Total} kr.`);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {icon}

      <Typography>
        <span style={{ display: "block" }}>{details.join(", ")}</span>
        {data.DueDate && (
          <span style={{ display: "block" }}>
            {locale.DueDate}: {moment.utc(data.DueDate).format("L")}
          </span>
        )}
      </Typography>
    </div>
  );
}
